import { createSlice, isAnyOf } from "@reduxjs/toolkit";
import { getCustomFieldsListAsync } from "../actions/omsPageActions";

interface CustomFieldItem {
  [key: string]: any;
}

interface PaginationState {
  pageNumber: number;
  count: number;
}

interface CustomFieldsState {
  loading: boolean;
  customFieldsList: CustomFieldItem[];
  pagination: PaginationState;
}

const initialState: CustomFieldsState = {
  loading: false,
  customFieldsList: [],
  pagination: {
    pageNumber: 1,
    count: 0,
  },
};

const omsCustomFieldsSlice = createSlice({
  name: "customFieldsSlice",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // PENDING
    builder.addMatcher(
      isAnyOf(getCustomFieldsListAsync.pending),
      (state) => {
        state.loading = true;
      }
    );

    // REJECTED
    builder.addMatcher(
      isAnyOf(getCustomFieldsListAsync.rejected),
      (state) => {
        state.loading = false;
      }
    );

    // FULFILLED
    builder.addMatcher(
      isAnyOf(getCustomFieldsListAsync.fulfilled),
      (state, action) => {
        state.loading = false;

        const res = action.payload;

        state.customFieldsList = res?.results?.data ?? [];
        state.pagination.count = res?.count ?? 0;
        state.pagination.pageNumber =
          action.meta.arg?.paramData?.page ?? 1;
      }
    );
  },
});

export default omsCustomFieldsSlice.reducer;
